// import request from '@/router/axios'
import {request} from '@/network/request'
// export function fetchList(query) {
//   return request({
//     url: '/gaoligong/progressWork/getFrontDynamicWork',
//     method: 'get',
//     params: query
//   })
// }

export function fetchList(query) {
  return request({
    url: '/gaoligong/progressWork/getDynamicWorkHome',
    method: 'get',
    params: query
  })
}
export function addObj(obj) {
  return request({
    url: '/gaoligong/progressWork',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/gaoligong/progressWork/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/gaoligong/progressWork/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/gaoligong/progressWork',
    method: 'put',
    data: obj
  })
}
